import { UserTaskStatus } from "@/openapi/generated";

export type UserTaskStatusTone = "neutral" | "info" | "success" | "danger";

export function getUserTaskStatusLabel(status: UserTaskStatus | string): string {
  switch (status) {
    case UserTaskStatus.Open:
      return "Open";
    case UserTaskStatus.InProgress:
      return "In progress";
    case UserTaskStatus.Completed:
      return "Completed";
    case UserTaskStatus.Cancelled:
      return "Cancelled";
    default:
      return String(status);
  }
}

export function getUserTaskStatusTone(
  status: UserTaskStatus | string,
): UserTaskStatusTone {
  switch (status) {
    case UserTaskStatus.Open:
      return "neutral";
    case UserTaskStatus.InProgress:
      return "info";
    case UserTaskStatus.Completed:
      return "success";
    case UserTaskStatus.Cancelled:
      return "danger";
    default:
      return "neutral";
  }
}

export function isUserTaskActive(status: UserTaskStatus | string): boolean {
  return (
    status === UserTaskStatus.Open || status === UserTaskStatus.InProgress
  );
}
